module.exports = __webpack_public_path__ + "icon_person_50black.f9f4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_person_50black.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_person_50black.svg
// module chunks = main